/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Criticality } from './Criticality';
import type { StatsOperationDatasetDto } from './StatsOperationDatasetDto';

export type StatsOperationNewIncidentDto = {
    createdDate: number;
    criticality: Criticality;
    datasets: Array<StatsOperationDatasetDto>;
    id: string;
    issueNo: number;
    lastOccurredDate: number;
    name: string;
    status: StatsOperationNewIncidentDto.status;
};

export namespace StatsOperationNewIncidentDto {

    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        CLOSED = 'CLOSED',
    }


}
